import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

// const namespace = ['utcom_unused', 'utcom'];

export type Translated = (key: any, ...ops: any[]) => string;
export interface InjectedTranslateProps {
  t: Translated;
  i18n: {
    language: string;
  };
  language: string;
  tReady: boolean;
}

export default function <P extends object>(
  BaseComponent:
    | React.ComponentClass<P & InjectedTranslateProps>
    | React.SFC<P & InjectedTranslateProps>
): React.ComponentClass<P> {
  class Translate extends React.Component<P & WithTranslation> {
    render() {
      return <BaseComponent {...this.props} t={this.t} language={this.props.i18n.language} />;
    }

    t = (key: any, ...ops: any[]) => {
      const {
        t,
        i18n: { language },
      } = this.props;

      if (!key) {
        return '';
      }

      switch (typeof key) {
        case 'object':
          return language in key ? key[language] : '';
        case 'string':
          return t(key, ...ops);
      }
      return '';
    };
  }
  // @ts-ignore
  return withTranslation()(Translate);
}
